import FormInput from 'components/Input/FormInput';
import React, { useCallback } from 'react';

interface IMasterPhoneField {
	changeMasterPhoneNumber: (value: string) => void;
}

const MasterPhoneField: React.FC<IMasterPhoneField> = ({ changeMasterPhoneNumber }) => {
	// const { t } = useTranslation('error');

	// const validationRules = useMemo<Rule[]>(
	// 	() => [
	// 		{ required: true, message: t('enterPhoneNumber') },
	// 		() => ({
	// 			validator(_, value) {
	// 				if (!value || value.replace(/\s/g, '').length === 12) {
	// 					return Promise.resolve();
	// 				}
	// 				return Promise.reject(new Error(t('phoneShouldContainDigits', { value: '11' })));
	// 			},
	// 		}),
	// 	],
	// 	[t],
	// );

	const handleChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			e.target.maxLength = 16;
			const withoutLetters = e.target.value.replace(/\D+$/g, '');
			// Regex below: https://stackoverflow.com/questions/70214348/phone-number-masking-without-plugin
			let validValue = withoutLetters
				.replace(/^(\d)/, '+7 $1')
				.replace(/(\+7\s\d{3})(\d)/, '$1 $2')
				.replace(/(\+7\s\d{3}\s\d{3})(\d)/, '$1 $2')
				.replace(/(\+7\s\d{3}\s\d{3}\s\d{2})(\d)/, '$1 $2')
				.replace(/(\+7\s\d{3}\s\d{3}\s\d{2}\s\d{2})\d+?$/, '$1');

			if (validValue === '+7') {
				validValue = '';
				changeMasterPhoneNumber('');
			} else if (validValue.length === 2 && validValue !== '+7') {
				validValue = '+7 ';
			}

			changeMasterPhoneNumber(validValue);
			return validValue;
		},
		[changeMasterPhoneNumber],
	);

	return (
		<FormInput
			testId="MasterPhoneField"
			name="masterPhoneNumber"
			label="masterPhoneNumberLabel"
			placeholder="0 000 000 00 00"
			getValueFromEvent={handleChange}
			// validationRules={validationRules}
		/>
	);
};

export default React.memo(MasterPhoneField);
